import Image from '@tiptap/extension-image';
import { mergeAttributes } from '@tiptap/react';

// Photos in descriptions: uploaded through the editor (backend/services/description_images), stored as
// <img src="/api/description-images/<id>" data-size="small|medium|full">. Anything else is not a photo here.
const API = process.env.REACT_APP_BACKEND_URL;
const SRC = /^(?:https?:\/\/[^/\s"'<>]+)?\/api\/description-images\/([0-9a-f]{32})$/;
export const PHOTO_SIZES = [{ value: 'small', name: 'Small' }, { value: 'medium', name: 'Medium' }, { value: 'full', name: 'Full width' }];
const SIZE_KEYS = PHOTO_SIZES.map((s) => s.value);
export const sizeKey = (v) => (SIZE_KEYS.includes(v) ? v : 'medium');

export const photoSrc = (src) => {
  const m = SRC.exec(src || '');
  return m ? `${API}/api/description-images/${m[1]}` : null;
};
export const isPhoto = (f) => /^image\//.test(f.type || '') || /\.(heic|heif)$/i.test(f.name || '');

// Inline, so a photo sits in its own paragraph and follows that paragraph's alignment.
export const DescriptionImage = Image.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      size: { default: 'medium', parseHTML: (el) => sizeKey(el.getAttribute('data-size')), renderHTML: (a) => ({ 'data-size': a.size }) },
    };
  },
  parseHTML() {
    return [{ tag: 'img[src]', getAttrs: (el) => (photoSrc(el.getAttribute('src')) ? null : false) }];
  },
  renderHTML({ HTMLAttributes }) {
    return ['img', mergeAttributes(HTMLAttributes, { src: photoSrc(HTMLAttributes.src), alt: HTMLAttributes.alt || '' })];
  },
}).configure({ inline: true });

// An uploaded photo → its own paragraph, at `pos` (a drop) or the cursor.
export function insertPhoto(editor, photo, pos) {
  const node = { type: 'paragraph', content: [{ type: 'image', attrs: { src: photo.src, width: photo.width, height: photo.height, size: 'medium' } }] };
  const chain = editor.chain().focus();
  (pos == null ? chain.insertContent(node) : chain.insertContentAt(pos, node)).run();
}
